import {Component, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcFileItem} from 'exc-upload-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ApplicationService} from '../../services/application.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-modal-attachment-upload',
  templateUrl: './modal-attachment-upload.component.html',
  styles: [],
})
export class ModalAttachmentUploadComponent
  extends ExcTranslation
  implements OnInit
{
  selectedFiles: ExcFileItem[] = [];
  uiSelectDocumentType = this.enumSvc
    .getEnumerationList('DokTyp')
    .find((e) => e.enmDefault).enmIdent;
  dokEigenschaftTypList: any[] = [];
  dokEigenschaftHelper: any = {};
  uiModel = {
    dokTrackingPortalShare: false,
    dokDescription: '',
    dokSize: 0,
    dokName: '',
    dok_objID: '',
    dokMIME: '',
    dokbIMG: '',
    dok_enmIdent_DokTyp: this.enumSvc.getEnumerationDefaultValue('DokTyp'),
    dokEigenschaft: [] as any[],
  };
  userType: number | any;

  private _MAXFILESIZE = environment.rest.MAXFILESIZE;
  selectedFilesChunked: ExcFileItem[][] = [];
  get MAXFILESIZE(): number {
    return this._MAXFILESIZE;
  }

  constructor(
    public popUpService: ExgModalService,
    public enumSvc: EnumerationService,
    public excSec: ExcSecurityService,
    public appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
    this.dokEigenschaftTypList = this.enumSvc.getDokEigenschaftTypList(
      this.uiModel.dok_enmIdent_DokTyp
    );
  }

  setDocumentType(e: any): void {
    this.uiSelectDocumentType = e;
    this.uiModel.dok_enmIdent_DokTyp = e;
    this.dokEigenschaftTypList = this.enumSvc.getDokEigenschaftTypList(
      this.uiModel.dok_enmIdent_DokTyp
    );
    this.dokEigenschaftHelper = {};
  }

  createDokEigenschaft(): void {
    this.uiModel.dokEigenschaft = [];
    // tslint:disable-next-line:forin
    for (const key in this.dokEigenschaftHelper) {
      this.uiModel.dokEigenschaft.push({
        dokEigID: key as unknown as number,
        dokEigValue: this.dokEigenschaftHelper[key],
      });
    }
  }

  upload(): void {
    if (this.getFiles().length === 0) {
      return;
    }
    this.createDokEigenschaft();
    const formData: any = ExcFileItem.getFormDataChunked(this.selectedFiles, {
      dok_enmIdent_DokTyp: this.uiModel.dok_enmIdent_DokTyp,
      dokBeschreibung: this.uiModel.dokDescription,
      dokTrackingPortalShare: this.uiModel.dokTrackingPortalShare,
      DokEigenschaft: this.uiModel.dokEigenschaft,
    });
    this.popUpService.action({ formData });
  }

  close(): void {
    this.popUpService.close();
  }

  onFilesSelect(files: ExcFileItem): void {
    this.selectedFiles = this.selectedFiles.concat(files);
  }

  onFilesSelectChunked(event: any[]): void {
    for (const eventElement of event) {
      this.selectedFilesChunked.push(eventElement);
    }
  }

  delete(deleteFile: any): void {
    this.selectedFiles = this.selectedFiles.filter(
      (file: any) => file !== deleteFile
    );
  }

  proofFileSize(size: number): boolean {
    return size < this.MAXFILESIZE;
  }

  getFiles(): any[] {
    const files = this.selectedFiles.filter((file: any) =>
      this.proofFileSize(file.size)
    );
    if (!files) {
      return [];
    }
    return files;
  }
}
